{
  "id": "campaign-100",
  "name": "Lights Out",
  "seed": "campaign:100",
  "startDir": "E",
  "mowerRule": {
    "kind": "minTier",
    "tier": 0
  },
  "rows": [
    "....L__L....",
    "...,.__.....",
    ".i.i,__.i.i.",
    ".*...__L..*.",
    ".....__.....",
    ".i.i.__.i.i.",
    "...*L__x*...",
    ".....__.....",
    ".i.i.__.i.i.",
    ".....__.....",
    ".....__x..L.",
    ".L..T__..,.~",
    "..h..__.,,,~",
    "....i__..,.~",
    ".i.i.__.i.i.",
    ".....__L....",
    "....~__..T..",
    ".i.~.__.....",
    "..#.~L..i.T.",
    "S..........."
  ],
  "critters": [
    {
      "kind": "squirrel",
      "x": 1,
      "y": 10
    },
    {
      "kind": "squirrel",
      "x": 7,
      "y": 8
    },
    {
      "kind": "squirrel",
      "x": 11,
      "y": 16
    },
    {
      "kind": "squirrel",
      "x": 1,
      "y": 15
    },
    {
      "kind": "rabbit",
      "x": 9,
      "y": 6
    }
  ],
  "pickups": [
    {
      "kind": "gas",
      "x": 7,
      "y": 7
    },
    {
      "kind": "gas",
      "x": 7,
      "y": 9
    },
    {
      "kind": "coin",
      "x": 5,
      "y": 9
    },
    {
      "kind": "coin",
      "x": 6,
      "y": 12
    },
    {
      "kind": "coin",
      "x": 6,
      "y": 5
    },
    {
      "kind": "coin",
      "x": 11,
      "y": 11
    },
    {
      "kind": "coin",
      "x": 6,
      "y": 6
    },
    {
      "kind": "coin",
      "x": 6,
      "y": 1
    },
    {
      "kind": "coin",
      "x": 5,
      "y": 2
    },
    {
      "kind": "coin",
      "x": 2,
      "y": 14
    },
    {
      "kind": "coin",
      "x": 0,
      "y": 16
    },
    {
      "kind": "coin",
      "x": 0,
      "y": 17
    },
    {
      "kind": "coin",
      "x": 7,
      "y": 2
    },
    {
      "kind": "coin",
      "x": 3,
      "y": 7
    },
    {
      "kind": "coin",
      "x": 10,
      "y": 11
    },
    {
      "kind": "coin",
      "x": 11,
      "y": 18
    },
    {
      "kind": "rare",
      "x": 5,
      "y": 7
    },
    {
      "kind": "repair",
      "x": 10,
      "y": 17
    }
  ],
  "generatorVersion": 3,
  "level": 100,
  "biome": "cemetery",
  "par": {
    "reel": 8392,
    "push": 7043,
    "selfPropelled": 6330,
    "tractor": 5845,
    "zeroTurn": 4168,
    "fairway": 3724
  },
  "dark": true
}
